import httpClient from '@/shared/http-eserv-client';

const submitContactRequest = (contactRequest) => httpClient.post('/ContactRequests', contactRequest);
const getStaticMessage = (messageType) => httpClient.get(`/StaticMessages/${messageType}`);
const getCountries = () => httpClient.get('/Countries');
const getProvinces = () => httpClient.get('/Provinces');
const companyData = (
  legalName,
  phoneNumber,
  faxNumber,
  address,
  addressLine2,
  cityName,
  postalCode,
  provinceName,
  countryName,
  createUser,
  source,
  sourceCompanyId,
) => httpClient.post('/Companies', {
  legalName,
  phoneNumber,
  faxNumber,
  address,
  addressLine2,
  cityName,
  postalCode,
  provinceName,
  countryName,
  createUser,
  source,
  sourceCompanyId,
});
const userInCompanies = (userId, companyId, createUser) => httpClient.post('/UserInCompanies', { userId, companyId, createUser });
const getUserInCompaniesbyUserId = (userId) => httpClient.get(`/UserInCompanies/${userId}`);
const getUserCompanyDatabyComapanyId = (companyId) => httpClient.get(`/Companies/${companyId}`);

export {
  // eslint-disable-next-line import/prefer-default-export
  submitContactRequest,
  getStaticMessage,
  getCountries,
  getProvinces,
  companyData,
  userInCompanies,
  getUserInCompaniesbyUserId,
  getUserCompanyDatabyComapanyId,
};
